<template>
  <div>
    <van-row
      type="flex"
      justify="center"
      class="OneTie OneTieactive"
      style="
        height: 32px;
        line-height: 32px;
        font-weight: 600;
        color: rgb(151, 121, 87);
        font-size: 14px;background-color:#E2CCB2;
      "
    >
      <van-col span="3"> </van-col>
      <van-col span="7" style="border-right: 1px solid rgba(0, 0, 0, 0.1)">
        Channel View
      </van-col>
      <van-col span="6" style="border-right: 1px solid rgba(0, 0, 0, 0.1)">
        Inv Value
      </van-col>
      <van-col span="6"> Inv Days </van-col>
    </van-row>

    <div class="box" v-for="(item, i) in tableList" :key="i">
      <van-row
        type="flex"
        justify="center"
        class="OneTie active OneTieactive"
        @click.prevent="showList($event)"
      >
        <van-col span="3">
          <div class="red">
            <img src="../../../assets/jpg/icon-1-down.png" alt />
          </div>
        </van-col>

        <van-col span="7">
          <div
            class="tableLeft"
            style="border-right: 1px solid rgba(0, 0, 0, 0.1)"
          >
            <div class="leftFlex">
              <span>{{ item.brandCd }}</span>
            </div>
          </div>
        </van-col>

        <van-col span="6">
          <div
            class="tableCenter"
            style="border-right: 1px solid rgba(0, 0, 0, 0.1)"
          >
            <div class="centerFlex">
              <span>{{ item.inv_value | NumFormat }}</span>
            </div>
          </div>
        </van-col>

        <van-col span="6">
          <div class="tableCenter">
            <div class="centerFlex">
              <span>
                {{ item.inv_days }}
              </span>
            </div>
          </div>
        </van-col>
      </van-row>

      <div
        v-show="isShow"
        v-for="item1 in item.levelList2ByBu"
        :key="item1.level1"
      >
        <van-row
          type="flex"
          @click.prevent="show($event)"
          justify="center"
          class="OneTie TwoTieactive"
        >
          <van-col span="3">
            <div v-show="item1.levelList3.length > 0" class="red">
              <img src="../../../assets/jpg/icon-2-right.png" alt />
            </div>
          </van-col>
          <van-col span="7">
            <div
              class="tableLeft"
              style="border-right: 1px solid rgba(0, 0, 0, 0.1)"
            >
              <div class="leftFlex">
                <span class="title">{{ item1.level1 }}</span>
              </div>
            </div>
          </van-col>
          <van-col span="6">
            <div
              class="tableCenter"
              style="border-right: 1px solid rgba(0, 0, 0, 0.1)"
            >
              <div class="centerFlex">
                <span class="invValue">{{ item1.inv_value | NumFormat }}</span>
              </div>
            </div>
          </van-col>

          <van-col span="6">
            <div class="tableCenter">
              <div class="centerFlex">
                <span class="invValue">
                  {{ item1.inv_days }}
                </span>
              </div>
            </div>
          </van-col>
        </van-row>

        <!-- v-show="isShow2" -->
        <van-row
          type="flex"
          justify="center"
          class="TwoTie"
          v-for="item2 in item1.levelList3"
          :key="item2.level3"
        >
          <van-col span="3"> </van-col>
          <van-col span="7">
            <div
              class="tableLeft"
              style="border-right: 1px solid rgba(0, 0, 0, 0.1)"
            >
              <div class="leftFlex">
                <span class="title">{{ item2.level2 }}</span>
              </div>
            </div>
          </van-col>
          <van-col span="6">
            <!-- tableCenter  centerFlex -->

            <div
              class="tableCenter"
              style="border-right: 1px solid rgba(0, 0, 0, 0.1)"
            >
              <div class="centerFlex">
                <span>{{ item2.inv_value | NumFormat }}</span>
              </div>
            </div>
          </van-col>

          <van-col span="6">
            <div class="tableCenter">
              <div class="centerFlex">
                <span>
                  {{ item2.inv_days }}
                </span>
              </div>
            </div>
          </van-col>
        </van-row>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import qs from "qs";

export default {
  data() {
    return {
      tableList: [],
      isShow: false,
      isShow2: false,
      achVing: sessionStorage.getItem("achVing"),
      type: "",
    };
  },
  methods: {
    getList() {
      this.$addr
        // .post("/getSalesData", qs.stringify({ brandCd: this.brandName }))
        // .get("http://10.216.226.81:8080/mobile_api/sellin/getBuByList")
        // .get("sellin/getBuByList")
        .get("sellinAndsellout/getBuByListSellInAndSellOutInv")
        .then((res) => {
          this.achVing = 0;
          this.achVing = parseFloat(sessionStorage.getItem("achVing"));
          this.tableList = res.data.data;
        })
        .catch((error) => {
          this.$toast("接受数据失败");
        });
    },
    getType() {
      this.$addr
        // .post("/getSalesData", qs.stringify({ brandCd: this.brandName }))
        // .get("http://10.216.226.81:8080/mobile_api/sellin/getBuByList")
        .get("sellin/getTargetType")
        .then((res) => {
          this.type = res.data.data;
        })
        .catch((error) => {
          this.$toast("接受数据失败");
        });
    },
    show(e) {
      console.log($(e.currentTarget).find(".red"));
      if ($(e.currentTarget).find(".red").attr("class") == "red") {
        $(e.currentTarget).find(".red").addClass("redPlusActive");
      } else {
        $(e.currentTarget).find(".red").removeClass("redPlusActive");
      }

      $(e.currentTarget).stop().nextAll(".TwoTie").slideToggle(500);
      $(e.currentTarget).stop().nextAll(".Map").slideToggle(500);
    },
    showList(e) {
      if ($(e.currentTarget).find(".red").attr("class") == "red") {
        $(e.currentTarget).find(".red").addClass("redPlusActiveImg");
      } else {
        $(e.currentTarget).find(".red").removeClass("redPlusActiveImg");
      }

      $(e.currentTarget).stop().nextAll().slideToggle(500);
    },
  },
  created() {
    this.getList();
    this.getType();
  },
};
</script>
<style scoped>
.OneTieactive {
  width: 104%;
  margin-left: -9px;
  background: #f2dec6;
  box-shadow: 0 5px 20px -10px #704f4f;
  border-radius: 10px;
  font-size: 12px;
}
.TwoTieactive {
  background: #faf1e7;
}
.TwoTieAct {
  background: #ffffff;
  margin-bottom: 8px;
  width: 96%;
  border-radius: 10px;
  margin-left: 7px;
}
.red {
  font-size: 16px;
  display: flex;
  align-items: center;
  /* padding: 0 10px; */
  /* height: 100%; */
}
.red img {
  width: 30px;
  height: 30px;
}
.LittleBut {
  height: 20px;
  width: 20px;
  text-align: center;
  background: rgba(158, 131, 108, 0.3);
  border-radius: 50%;
  line-height: 20px;
}
.notice {
  background: #c7544d !important;
}
.noticeCol {
  background: #f9c6bd !important;
}
.noticeFormat {
  color: #c7544d !important;
}
.helthyFormat {
  color: #84a05f !important;
}
.pinFormat {
  color: #e9c978 !important;
}
.helthyCol {
  background: #d4e1b4 !important;
}
.pinCol {
  background: #e0c681 !important;
}
.helthy {
  background: #84a05f !important;
}
.pin {
  background: #f3d480 !important;
}
.list {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.list b {
  text-align: right;
  min-width: 50px;
  font-family: "微软雅黑" !important;
  height: 37px;
  line-height: 37px;
  font-size: 15px;
  color: #3a3a3b;
}
.list span {
  text-align: left;
  font-family: "微软雅黑" !important;
  height: 37px;
  min-width: 50px;
  line-height: 37px;
  font-size: 15px;
  color: #3a3a3b;
}
.tableLeft {
  /* padding: 12px 5px 13px 22px; */
  display: flex;
  justify-content: flex-start;
  align-items: center;
  min-height: 45px;
}
.tableLeft .tableTop {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.title {
  font-weight: 600;
}

.tableLeft .tableTop span {
  font-family: "微软雅黑" !important;
  font-size: 12px;
  color: #3a3a3b;
  white-space: nowrap;
}

.tableLeft .tableTop b {
  font-family: "微软雅黑" !important;
  font-size: 14px;
}
.TwoTie .progress {
  width: 90.2%;
}
.TwoTie .tableLeft .tableTop span {
  overflow: hidden;
  white-space: nowrap;
}
.progress {
  margin-top: 16px;
  width: 100%;
}
.progress span {
  width: 100%;
  display: block;
  background: #dddde9;
  border-radius: 5px;
  height: 12px;
}
.progress span p {
  display: block;
  width: 50%;
  font-family: "微软雅黑" !important;
  font-size: 10px;
  color: #f6f6ff;
  line-height: 12px;
  border-radius: 5px;
  text-align: right;
  padding-right: 6px;
}
.tableLeft .leftFlex span {
  font-family: "微软雅黑" !important;
  font-weight: 600;
  font-size: 12px;
}

.tableCenter .centerFlex span {
  font-family: "微软雅黑" !important;
  font-weight: 600;
  font-size: 12px;
  color: #443b72;
}

.tableCenter {
  /* padding: 12px 5px 13px 22px; */
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: column;
  min-height: 45px;
}

.tableLeft b {
  font-family: "微软雅黑" !important;
  font-size: 15px;
  color: #84a05f;
}
.tableRight {
  padding: auto 4px;
  margin: 12px 0 0 4px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.tableRight .rightFlex {
  position: relative;
  margin-bottom: 1px;
  width: 100%;
  display: flex;
  justify-content: space-around;
}
.tableRight .rightFlex span {
  min-width: 60px;
  font-family: "微软雅黑" !important;
  font-size: 11px;
  color: #3a3a3b;
  text-align: right;
}
.tableRight .rightFlex b {
  text-align: left;
  min-width: 50px;
  font-family: "微软雅黑" !important;
  font-size: 10px;
  color: #332a66;
}
.tableRight .rightFlex i {
  font-style: normal;
  text-align: left;
  min-width: 60px;
  font-family: "微软雅黑" !important;
  font-size: 11px;
  color: #3a3a3b;
}
.tableRight .rightFlex img {
  position: absolute;
  width: 12px;
  height: 12px;
  left: 8px;
  top: -1px;
}
.box {
  margin: 1.5px auto 0;
  padding: 0 14px;
  position: relative;
}
.OneTie {
  position: relative;
  text-align: right;
  margin-left: 5px;
  width: 97%;
  height: 50px;
  box-shadow: 0 5px 20px -10px #704f4f;
  border-radius: 10px;
  line-height: 17px;
  text-align: center;
  font-family: "微软雅黑" !important;
  font-size: 12px;
  color: #000000;
  z-index: 999;
  margin-bottom: 10px;
}
.active {
  width: 103%;
  margin-left: -7px;
  box-shadow: 0 5px 20px -10px #704f4f;
  border-radius: 10px;
  font-size: 12px;
}
.ly {
  margin-left: 10px;
  display: inline-block;
  width: 40px;
  height: 12px;
  line-height: 12px;
  text-align: center !important;
  border-radius: 6px;
  background: #d4e1b4;
}
.TwoTie {
  text-align: center;
  font-family: "微软雅黑" !important;
  font-size: 11px;
  color: #191919;
  width: 97%;
  height: 70px;
  border-bottom: 2px solid rgba(157, 157, 157, 0.4);
  line-height: 17px;
  padding: 0 10px;
}
.redPlusActive > img {
  transform: rotate(90deg);
}
.redPlusActiveImg > img {
  transform: rotate(90deg);
}
.red {
  transform: rotate(-90deg);
}
</style>


// WEBPACK FOOTER //
// src/components/ButSecoend2/Bu-IC/BuTable.vue